import { useState } from 'react';

import WarningModal from '../../components/warning-modal/warning-modal.component';
import { Vehicle } from '../../types/vehicle.type';
import { userSdk } from '../../services/user.service';

type Props = {
    vehicle: Vehicle;
    onDone: () => void;
};

const DeleteVehicleModal = ({ vehicle, onDone }: Props) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const onConfirm = async () => {
        if (loading) return;

        setError('');
        setLoading(true);
        const response = await userSdk.deleteVehicle(vehicle.id);
        setLoading(false);
        if ('error' in response) {
            setError(response.error);
            return;
        }
        onDone();
    };

    return (
        <WarningModal
            title="Eliminar vehículo"
            body={
                vehicle.insurance != null
                    ? 'Este vehículo tiene un seguro activo. Eliminarlo romperá la trazabilidad con el proveedor. ¿Continuar de todos modos?'
                    : `Esto eliminará el vehículo ${vehicle.plate} de forma permanente. ¿Continuar?`
            }
            note="Esta acción no puede ser revertida."
            onConfirm={onConfirm}
            onDiscard={onDone}
            confirmText="Eliminar"
            discardText="Cancelar"
            confirmLoading={loading}
            error={error}
        />
    );
};

export default DeleteVehicleModal;
